// extracted by mini-css-extract-plugin
export default {"days":"Days_days__k0Rl6","day":"Days_day__CI-oi","day__teacher":"Days_day__teacher__ZCr97","day__classroom":"Days_day__classroom__MxgK4","day__holiday":"Days_day__holiday__FKpAx"};